// 编辑团队空间接口错误码
export const updateTeamSpacesErrorCodeMap = {
  'space.not.exists': '空间不存在',
  'duplicate.name.error': '存在重名，请修改',
  'name.length.exceed': '名称长度超出限制',
  'name.contain.special.characters': '名称包含特殊字符',
  'unsupported.file.type': '不支持的文件格式'
}
